import styled from 'styled-components';

// CONSTANTS
import { WHITE } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.section`
  background-color: ${WHITE};
  padding-top: 60px;
  padding-bottom: 60px;
  text-align: center;

  .shows-movies {
    &__img {
      img {
        max-width: 100%;
      }
    }
  }

  .search {
    &__input {
      .MuiOutlinedInput-notchedOutline {
        border-color: ${p => p.theme.palette.primary.main};
      }
    }
  }

  ${breakpoints.down('xs')} {
    padding-top: 40px;
  }
`;

export default Container;
